<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-toolbar flat height="90">
                <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.addBrand[lang]"
                    @click="openNewCollabDialog"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-col cols="12" sm="4" class="pa-0">
                    <b-search-field v-model="search"></b-search-field>
                </v-col>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="collaborators"
                :footer-props="{
                    itemsPerPageOptions: [12],
                    showCurrentPage: true,
                    pageText: `${page * 12 - 11}-${
                        page * 12 <= serverItemsLength
                            ? page * 12
                            : serverItemsLength
                    } ${
                        translations.paginationText[lang]
                    } ${serverItemsLength}`,
                }"
                :page.sync="page"
                :server-items-length="serverItemsLength"
                :options.sync="options"
                class="b-outlined"
                :loading="loading"
            >
            <template v-slot:item.status.name="{ item }">
                {{ translations[item.status.name.toLowerCase()][lang] }}
            </template>

            <template v-slot:item.actions="{ item }">
                            <v-tooltip v-for="action in item.actions" :key="action" color="secondary" top>
                                <template v-slot:activator="{ on }">
                                    <v-btn 
                                        color="secondary"
                                        icon
                                        v-on="on"
                                        @click="startActing({synergy_id:item.company_synergy_id, action})"
                                    >
                                        <v-icon
                                            v-text="icons[action]"
                                        ></v-icon>
                                    </v-btn>
                                </template>
                                <span
                                    class="font-weight-bold"
                                    v-text="translations[action][lang]"
                                ></span>
                            </v-tooltip>
                        </template>
            </v-data-table>
        </v-sheet>
        <v-dialog
            v-model="newCollabDialog"
            :max-width="
                $vuetify.breakpoint.smAndDown ? '90%' : '40%'
            "
        >
            <b-card
                :title="this.translations.addNewCollaborator[this.lang]"
                @cancel="newCollabDialog = false"
                @submit="submitNewSynergy"
                style="min-height:300px"
                :disabled="false"
                :submit-text="this.translations.addBrand"
                :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
            >
                <v-col cols="12" class="pr-2">
                    {{ this.translations.chooseCollaborator[this.lang] + ': ' }}
                    <v-autocomplete
                        :items="companies"
                        :search-input.sync="searchCompanies"
                        :label="translations.chooseCollaborator[lang]"
                        :loading="companiesLoading"
                        item-color="secondary"
                        color="black"
                        autocomplete
                        single-line
                        v-model="newCollaboratorData"
                        item-text="name"        
                        item-value="store_id"
                        return-object
                    >
                        <template v-slot:selection="data">
                            <!-- <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                x-large
                                @click="data.select"
                                @click:close="remove(data.item)"
                                >
                                <v-avatar left>
                                    <v-img :src="data.item.logo"></v-img>
                                </v-avatar>
                                {{ data.item.name }}
                            </v-chip> -->
                            <template>
                            <v-list-item-avatar>
                                <img :src="data.item.logo">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                            </v-list-item-content>
                            </template>
                        </template>
                            <template v-slot:item="data">
                            <template>
                            <v-list-item-avatar>
                                <img :src="data.item.logo">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                            </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-col>
            </b-card>
        </v-dialog>
    </v-container>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/collaborators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import debounce from "lodash/debounce";
import { mdiCancel, mdiCheckBold, mdiEmailSyncOutline, mdiPlay } from "@mdi/js";

export default {
    name: "Collaborators",

    mixins: [translations],

    data() {
        return {
            icons: {
                enable: mdiCheckBold,
                disable: mdiCancel,
                resend: mdiEmailSyncOutline,
                accept: mdiCheckBold,
            },
            itemsPerPageOptions: [10, 20, 30, -1],
            page: +this.$route.query.page,
            newCollaboratorData: {},
            newCollabDialog: false,
            search: "",
            options: {},
            searchCompanies: '',
            filtersData: {
                order: null,
            },
        }
    },
    methods: {

        ...mapActions("loyaltyPanel/collaborators", [
            "loadCompanies",
            "loadSynergies",
            "doAction",
            "addNewCollaborator"
        ]),

        async openNewCollabDialog(){
            this.newCollabDialog = true
            await this.loadCompanies()
        },

        async submitNewSynergy(){
            await this.addNewCollaborator(this.newCollaboratorData)
            this.newCollabDialog = false
            await this.getFilteredData()
        },

        async startActing(actionData){
            await this.doAction(actionData)
            await this.getFilteredData()
        },

        async getFilteredData() {
            await this.loadSynergies(this.sendingData);
        },
       
    },
    computed: {

        ...mapGetters("loyaltyPanel/collaborators", [
            "companies", 
            "companiesLoading", 
            "serverItemsLength",
            "loading", 
            "collaborators"
            ]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                { text: this.translations.fromCompany[this.lang], value: "from_company.name" },
                { text: this.translations.toCompany[this.lang], value: "to_company.name" },
                { text: this.translations.status[this.lang], value: "status.name" },
                { text: this.translations.actions[this.lang], value: "actions" },
            ];
        },
        
        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }
            if(this.search){
              query += `q=${this.search}&`
            }
            return query.slice(0, query.length - 1);
        },

        sendingData() {
            return {
                query: this.query,
                filters: this.filtersData,
            }
        },
    },
      watch: {
        options: {
            handler(val, oldVal) {
                if (val.sortBy[0]) {
                    this.filtersData.order = val.sortBy[0].split("[")[0];

                    if (val.sortDesc) {
                        this.filtersData.order +=
                            "," + (val.sortDesc[0] ? "desc" : "asc");
                    }

                    if (
                        oldVal.sortDesc[0] === undefined ||
                        oldVal.sortDesc[0] !== val.sortDesc[0]
                    ) {
                        if (this.page !== 1) {
                            this.page = 1;
                        } else {
                            this.getFilteredData();
                        }
                    }
                }
            },
            deep: true,
        },
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getFilteredData();
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getFilteredData();
            } else {
                this.debouncedSearch();
            }
        },
        searchStores() {
            this.storesPage = 1
            this.loadStores({
                query: this.storesQuery,
                page: this.storesPage,
            });
        },
    },
    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    created() {
        this.debouncedSearch = debounce(this.getFilteredData, 500);
    },

    mounted() {
        this.getFilteredData();
    },
};
</script>
